import React, { useState } from "react";
import { Modal, Table, Alert, Button } from "antd";
import { ThunderboltOutlined } from "@ant-design/icons";
import { refreshDocument } from "../../api/api";

interface ProcessModalProps {
  show: boolean;
  onHide: () => void;
  document: {
    id: string;
    title: string;
    dateModified: string;
    status: string;
    metadata?: { key: string; value: string }[];
    user: string;
  };
}

const ProcessModal: React.FC<ProcessModalProps> = ({
  show,
  onHide,
  document,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleProcess = async () => {
    setLoading(true);
    setError(null);

    try {
      await refreshDocument(document.id);
      onHide();
    } catch (error) {
      setError("Failed to Process the document. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const documentColumns = [
    {
      title: 'Field',
      dataIndex: 'field',
      key: 'field',
      width: '30%',
    },
    {
      title: 'Value',
      dataIndex: 'value',
      key: 'value',
    },
  ];

  const documentData = [
    { key: '1', field: 'Title', value: document.title },
    { key: '2', field: 'Added On', value: document.dateModified },
    { key: '3', field: 'User', value: document.user },
    { key: '4', field: 'Status', value: document.status },
  ];

  if (document.metadata && document.metadata.length > 0) {
    document.metadata.forEach((meta, index) => {
      documentData.push({
        key: `meta-${index}`,
        field: meta.key,
        value: meta.value,
      });
    });
  }

  return (
    <Modal
      title={
        <span>
          <ThunderboltOutlined style={{ marginRight: 8 }} />
          Document Details
        </span>
      }
      open={show}
      onCancel={onHide}
      footer={[
        <Button key="cancel" onClick={onHide} disabled={loading}>
          Cancel
        </Button>,
        <Button key="process" type="primary" danger onClick={handleProcess} loading={loading}>
          Process
        </Button>,
      ]}
      centered
      width={600}
    >
      {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}
      
      <Table
        columns={documentColumns}
        dataSource={documentData}
        pagination={false}
        bordered
        size="small"
      />
    </Modal>
  );
};

export default ProcessModal;
